import type { ReactNode } from "react";

export function SafeAreaProvider({ children }: { children: ReactNode }) {
  return children;
}
